import { Component, OnInit } from '@angular/core';
import { TalentProfilePage } from "../../../enums";
import { PageService } from "../shared/page-service";
import { TalentHappyPathDataService } from "../../shared/service/talent-happy-path-data-service";
import { TalentProfileApiService } from "../talent-profile-api.service";
import { ActivityType } from "../../../enums";
import { ActivatedRoute, Router } from "@angular/router";
import { sendDoThisLaterEmail } from "../../shared/util/talent-happy-path-util";

@Component({
    selector: 'app-employment-splash-page',
    templateUrl: './employment-splash-page.component.html',
    styleUrl: './employment-splash-page.component.scss',
    standalone: false
})
export class EmploymentSplashPageComponent implements OnInit {

  talent: Talent;
  posting: PostingInfo;
  isModalVisible: boolean = false;

  constructor(
    private pageService: PageService,
    private talentProfileApiService: TalentProfileApiService,
    private talentHappyPathDataService: TalentHappyPathDataService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.talent = this.talentHappyPathDataService.talent;
    this.posting = this.talentHappyPathDataService.postingInfo;
    this.talentProfileApiService.showProfileForTalent(this.talent.personId).subscribe(
      showProfile => {
        if (!showProfile) {
          this.router.navigateByUrl('/thank-you', { skipLocationChange: true });
        }
      }
    );
  }

  goToEmploymentOpportunities(event?: MouseEvent) {
    this.saveActivity();
    this.pageService.setActivePage(TalentProfilePage.EMPLOYMENT_OPPORTUNITIES);
  }

  saveActivity() {
    this.talentProfileApiService.createTalentProfileActivity(
      ActivityType.TALENT_PROFILE_MODULE_STARTED,
      this.talent.personId,
      this.posting?.orderId,
      this.posting?.jobPostingId
    ).subscribe();
  }

  doThisLater() {
    if (!this.talentHappyPathDataService.doThisLaterEmailSent) {
      sendDoThisLaterEmail(
        this.posting?.jobPostingId ?? null,
        this.talent.personId,
        this.talent.firstName,
        this.talent.lastName,
        this.talent.email,
        this.posting?.jobTitle ?? null,
        this.posting?.orderId ?? null,
        this.talentProfileApiService,
        this.talentHappyPathDataService.isGeneralApplication
      )
    }
  }

  openDoLaterModal(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isModalVisible = true;
  }

}
